import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const [pw, setPw] = useState("");
  const nav = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/reset-password", { token, new_password: pw }); toast.success("Password reset. Sign in!"); nav("/login"); }
    catch (e) { toast.error(formatApiErrorDetail(e?.response?.data?.detail)); }
  };
  return (
    <div className="max-w-md mx-auto px-6 py-24">
      <h1 className="font-display text-4xl">Set a new password</h1>
      <form onSubmit={submit} className="mt-6 space-y-3">
        <input required type="password" placeholder="New password" value={pw} onChange={e=>setPw(e.target.value)} className="w-full px-4 py-3 rounded-lg border"/>
        <button className="btn-wine w-full justify-center">Reset password</button>
      </form>
      <div className="mt-6 text-sm"><Link to="/login" className="text-[color:var(--wine)] underline">Back to sign in</Link></div>
    </div>
  );
}
